import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'
import pathify from "./pathify";
import axios from 'axios';
import { Model } from 'vue-api-query';

import actions from "./modules/actions";
import auth from "./modules/auth";
import charts from "./modules/charts";
import chartTypes from "./modules/chartTypes";
import clients from "./modules/clients";
import insights from "./modules/insights";
import tags from "./modules/tags";
import targets from "./modules/targets";
import users from "./modules/users";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: 'wonderful-bit',
    storage: window.localStorage,
    reducer: state => ({
        auth: state.auth,
    })
})

// store
const store = new Vuex.Store({
    // ...root,

    modules: {
        actions,
        auth,
        charts,
        chartTypes,
        clients,
        insights,
        tags,
        targets,
        users,
    },

    plugins: [pathify.plugin, vuexLocal.plugin]
});

export default store;

// inject global axios instance as http client to Model
Model.$http = axios
